import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { MaxShipping } from '../../../../../typings'
import styles from '../styles'
import { ReviewProps } from './constants'
import { messages } from './messages'

type Props = ReviewProps & {
  config: MaxShipping
}

export function MaxShippingReview(props: Props) {
  const { config } = props
  const { formatCurrency } = useNumbers()

  return (
    <SummaryRow.Value className={styles.flexRow}>
      <FormattedMessage
        {...messages.maxShipping}
        values={{
          tag: (content) => <Tag>{content}</Tag>,
          discount: formatCurrency(config.value),
        }}
      />
    </SummaryRow.Value>
  )
}
